import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getProjectsOfUser, getProjectOfUser } from "../../actions/projectActions";

import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter
} from "react-router-dom";

import Spinner from "./Spinner/Spinner";
import SideNav from "./SideNav/SideNav";
import TopNav from "./TopNav/TopNav";
import Dashboard from "../dashboard/Dashboard";
import Karte from "../map/Map";
import Workflow from "../workflow/Workflow";
import NotFound from "../404/404";

import "./Layout.scss";

class Layout extends Component {

  componentDidMount() {
    this.props.getProjectsOfUser(this.props.auth.user.user_id);
	if (localStorage.getItem('user_id') && localStorage.getItem('project_id') && localStorage.getItem('object_id') && localStorage.getItem('start_lat') && localStorage.getItem('start_long') && localStorage.getItem('start_zoom')) {
	  this.props.getProjectOfUser(localStorage.getItem('user_id'), localStorage.getItem('project_id'), localStorage.getItem('object_id'));
	}
  }
  
  render() {
    const { projects, projectsLoading } = this.props.projects;
    
	let layoutContent;
	
    if (projects === null || projectsLoading) {
      layoutContent = <Spinner />;
    } else if (projects.length > 0) {
      layoutContent = (
        <>
		  <SideNav projects={projects} />
          <div className="right no-side">
            <TopNav />
			<Switch>
              <Route
                exact
                path="/dashboard"
                projects={projects}
                component={Dashboard}
              />
              <Route
                exact
                path="/map"
                component={Karte}
              />
			  <Route
                exact
                path="/workflow/:id"
                component={Workflow}
              />
              <Route component={NotFound} />
            </Switch>
          </div>

        </>
      );
    } else {
      layoutContent = (
        <>
		  <SideNav projects={projects} />
		  <div className="right">
            <TopNav />
			<Switch>
              <Route
                exact
                path="/dashboard"
                projects={[]}
                component={Dashboard}
              />
              <Route
                exact
                path="/map"
                component={Karte}
              />
			  <Route
                exact
                path="/workflow/:id"
                component={Workflow}
              />
              <Route component={NotFound} />
            </Switch>
          </div>

        </>
      );
    }


    return (
      <Router>
        <div className="wrapper">{layoutContent}</div>
      </Router>
    );
  }
}

Layout.propTypes = {
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  projects: state.projects
});

export default withRouter(
  connect(
    mapStateToProps,
    { getProjectsOfUser,
      getProjectOfUser	}
  )(Layout)
);